import { Model } from 'shared/services/api/models/Model'
import { LetterboxDocumentV1 } from './letterboxResponses'
import { LetterboxDocumentContent } from './letterboxDocumentContent'
import MountPoints from 'shared/utils/mountPoints'

export class LetterboxDocument extends Model {
  public readonly orderId: string
  public readonly customerId: string
  public readonly type: string
  public readonly date: string
  public readonly since: string
  public readonly content: LetterboxDocumentContent
  public url: string = ''

  constructor(src: LetterboxDocumentV1) {
    super(src)
    this.content = new LetterboxDocumentContent(src.content)
    this.customerId = src.customer_id
    this.date = src.date
    this.orderId = src.order_id
    this.since = src.since
    this.type = src.type
  }

  getDocumentURL(mountPoints: MountPoints): string {
    this.url = mountPoints.getLetterboxDocumentURL(this)
    return this.url
  }
}
